const config = {
  env: 'prod',
  region: 'apac',
  page: '/ocp-dashboard',
  path: 'api/v2',
  get baseUrl() {
    return `${this.page}/${this.env}-${this.region}/${this.path}`;
  },
};

export const IOT_GROUP_REGISTRATION_DEV =
  'group:default/dpo-plugin-iot-reg-dev-eu';
export const IOT_GROUP_REGISTRATION_STAGING =
  'group:default/dpo-plugin-iot-reg-staging-global';
export const IOT_GROUP_REGISTRATION_PROD_EMEA =
  'group:default/dpo-plugin-iot-reg-prod-eu';
export const IOT_GROUP_REGISTRATION_PROD_APAC =
  'group:default/dpo-plugin-iot-reg-prod-apmea';
export const IOT_GROUP_REGISTRATION_PROD_AMER =
  'group:default/dpo-plugin-iot-reg-prod-amer';

export const updateRegionAndEnv = (env: string, region: string) => {
  config.env = env;
  config.region = region;
};

export const CONFIG = config;
